import type { FC } from 'react';

import { useHeaderInteractor } from './interactor';
import { HeaderRouter } from './router';

export const Header: FC = () => {
  const interactor = useHeaderInteractor();
  return <HeaderRouter interactor={interactor} />;
};
